export default __webpack_public_path__ + "static/media/eWallet_logo.a43a9d42.svg";